import constants from '../constants/courseTree';

const isCourseTreeUpdated = versionTimestamp =>
  Date.now() - versionTimestamp < constants.oneDay;

export default isCourseTreeUpdated;
